interface LastUsedBadgeProps {
  label: string;
  /**
   * `subtle` (default) renders an indigo-tinted pill for light surfaces such as
   * the OAuth buttons. `onPrimary` renders a white pill for use on a filled
   * primary (indigo) button.
   */
  variant?: 'subtle' | 'onPrimary';
}

/**
 * A small "Last used" pill that marks the auth method a returning user picked
 * last time. It sits on the top edge of its (relatively positioned) parent
 * button, at the trailing end, so it never covers the button's label however
 * long the translation; `end` keeps it there in right-to-left languages.
 */
export default function LastUsedBadge({
  label,
  variant = 'subtle',
}: LastUsedBadgeProps) {
  const styles =
    variant === 'onPrimary'
      ? 'bg-white text-primary-700 ring-primary-600/20 dark:bg-[#1c1a36] dark:text-primary-200 dark:ring-primary-300/30'
      : 'bg-primary-50 text-primary-700 ring-primary-600/20 dark:bg-[#1c1a36] dark:text-primary-200 dark:ring-primary-300/30';

  return (
    <span
      className={`pointer-events-none absolute -top-2.5 end-5 inline-flex items-center rounded-full px-2 py-[3px] text-[11px] font-semibold leading-none shadow-[0_1px_2px_rgba(16,16,40,0.08)] ring-1 ring-inset ${styles}`}
    >
      {label}
    </span>
  );
}
